var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGenericDigitalInput(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#B8CC9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5555 19.3054C16.5555 21.1003 15.1005 22.5554 13.3055 22.5554C11.5106 22.5554 10.0555 21.1003 10.0555 19.3054C10.0555 17.5105 11.5106 16.0554 13.3055 16.0554C15.1005 16.0554 16.5555 17.5105 16.5555 19.3054ZM11.0305 19.3054C11.0305 20.5619 12.0491 21.5804 13.3055 21.5804C14.562 21.5804 15.5805 20.5619 15.5805 19.3054C15.5805 18.049 14.562 17.0304 13.3055 17.0304C12.0491 17.0304 11.0305 18.049 11.0305 19.3054Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9445 19.3054C25.9445 21.1003 24.4894 22.5554 22.6945 22.5554C20.8995 22.5554 19.4445 21.1003 19.4445 19.3054C19.4445 17.5105 20.8995 16.0554 22.6945 16.0554C24.4894 16.0554 25.9445 17.5105 25.9445 19.3054ZM20.4195 19.3054C20.4195 20.5619 21.438 21.5804 22.6945 21.5804C23.9509 21.5804 24.9695 20.5619 24.9695 19.3054C24.9695 18.049 23.9509 17.0304 22.6945 17.0304C21.438 17.0304 20.4195 18.049 20.4195 19.3054Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.2222,
    y: 18.9443,
    width: 5.77778,
    height: 1.44444,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18.9443,
    width: 5.77778,
    height: 1.44444,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 8.66667,
    height: 1.15819,
    transform: "matrix(0.751737 0.659463 0.659463 -0.751737 14.3889 11.8706)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericDigitalInput);
export default __webpack_public_path__ + "static/media/generic-digital-input.0051feb67ff7f2b489dd9cbd59222639.svg";
export { ForwardRef as ReactComponent };